import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";

// Cabecera de columna ordenable: al pulsarla alterna ascendente/descendente. Pensada para
// listados con la ordenación hecha en el servidor (con paginación, ordenar solo la página visible
// daría un orden engañoso).
export function SortHeader({ label, active, dir, onClick }: { label: string; active: boolean; dir: "asc" | "desc"; onClick: () => void }) {
  const Icon = !active ? ArrowUpDown : dir === "asc" ? ArrowUp : ArrowDown;
  return (
    <button
      type="button"
      onClick={onClick}
      className={`inline-flex items-center gap-1 font-semibold transition-colors hover:text-ink-700 ${active ? "text-ink-700" : ""}`}
    >
      {label}
      <Icon className="h-3.5 w-3.5" />
    </button>
  );
}

export type SortState<K extends string> = { key: K; dir: "asc" | "desc" };

export function nextSort<K extends string>(current: SortState<K>, key: K): SortState<K> {
  return current.key === key ? { key, dir: current.dir === "asc" ? "desc" : "asc" } : { key, dir: "asc" };
}
